import {download} from 'permissions/panel/reports/actions'

import Report from 'components/Report/Report'
import {withPermission} from 'containers/withPermission'

export default withPermission({
    isDownloadActive: download,
})(Report)